import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg';
  shadow?: 'sm' | 'md' | 'lg';
  hover?: boolean;
}

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  padding = 'md',
  shadow = 'md',
  hover = false,
}) => {
  const { isBlack } = useTheme();
  const baseClasses = isBlack
    ? 'bg-black/25 border border-white/10 rounded-xl backdrop-blur-[2px] transition-all duration-200 text-white'
    : 'bg-white dark:bg-gray-800/80 dark:backdrop-blur-sm border border-gray-200 dark:border-white/5 rounded-lg dark:rounded-xl transition-all duration-300 text-gray-900 dark:text-gray-100';
  
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  const shadowClasses = {
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg',
  };

  const hoverClasses = hover 
    ? (isBlack
        ? 'hover:shadow-lg hover:-translate-y-1 hover:bg-white/5'
        : 'hover:shadow-lg hover:shadow-gray-200/50 dark:hover:shadow-black/60 dark:hover:border-accent1/30 hover:-translate-y-1 hover:bg-yellow-100/10 hover:text-yellow-600 dark:hover:text-yellow-400')
    : '';

  const combinedClasses = `
    ${baseClasses}
    ${paddingClasses[padding]}
    ${shadowClasses[shadow]}
    ${hoverClasses}
    ${className}
  `.trim();

  return (
    <div className={combinedClasses}>
      {children}
    </div>
  );
};